/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const FactoryGptIcon: React.FC<AllieIconProps & { width?: string }> = ({ width = '24' }) => (
  <svg width={width} height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5 22.1074V17.1074M4.5 7.10736V2.10736M2 4.60736H7M2 19.6074H7M13 3.10736L11.2658 7.61622C10.9838 8.34945 10.8428 8.71607 10.6235 9.02445C10.4292 9.29776 10.1904 9.53655 9.91709 9.73089C9.60871 9.95017 9.24209 10.0912 8.50886 10.3732L4 12.1074L8.50886 13.8415C9.24209 14.1235 9.60871 14.2646 9.91709 14.4838C10.1904 14.6782 10.4292 14.917 10.6235 15.1903C10.8428 15.4987 10.9838 15.8653 11.2658 16.5985L13 21.1074L14.7342 16.5985C15.0162 15.8653 15.1572 15.4987 15.3765 15.1903C15.5708 14.917 15.8096 14.6782 16.0829 14.4838C16.3913 14.2646 16.7579 14.1235 17.4911 13.8415L22 12.1074L17.4911 10.3732C16.7579 10.0912 16.3913 9.95017 16.0829 9.73089C15.8096 9.53655 15.5708 9.29776 15.3765 9.02445C15.1572 8.71607 15.0162 8.34945 14.7342 7.61622L13 3.10736Z"
      stroke="#D0D5DD"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
